__turbopack_context__.v({
  "className": "gd4nkW_className",
  "variable": "gd4nkW_variable",
});
